<textbox-range *ngIf="rangeView" [view]="rangeView" (onValueChange)="notifyValueChange($event)" > </textbox-range>
